module.exports = __webpack_public_path__ + "static/media/instagram-ios.314a4733.png";